/**
 * Converts a file blob to a base64 string.
 * Useful for handling audio or image blobs before upload or for local preview.
 */
export const blobToBase64 = (blob: Blob): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = () => {
      const result = reader.result;
      if (typeof result === 'string') {
        const commaIndex = result.indexOf(',');
        if (commaIndex !== -1) {
          const base64data = result.slice(commaIndex + 1);
          resolve(base64data);
          return;
        }
      }
      reject(new Error('Failed to parse base64 data from blob'));
    };
    reader.onerror = (error) => {
      reject(error);
    };
  });

/**
 * Reassembles an array of base64-encoded binary chunks into a single Blob.
 * Returns null if the array is empty or any chunk fails to decode.
 * @param chunks Base64-encoded chunks, in order.
 * @param mimeType MIME type for the resulting Blob (default "audio/mpeg").
 */
export const base64ChunksToBlob = (chunks: string[], mimeType = 'audio/mpeg'): Blob | null => {
  if (!chunks || chunks.length === 0) return null;
  try {
    const binary = chunks.map((chunk) => atob(chunk)).join('');
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) {
      bytes[i] = binary.charCodeAt(i);
    }
    return new Blob([bytes], { type: mimeType });
  } catch {
    return null;
  }
};
